import { useState, useCallback, useEffect, useRef } from "react";
import { Box, Button, Card, Grid, Tooltip } from "@material-ui/core";
import { useStyles } from "../../../clientes/components/clientes-list/clientes-list-styles";
import { CircularLoading } from "views/components/utils/circular-loading/circular-loading";
import { useDefaultCadastroStyles } from "views/pages/private/cadastros/components/default-cadastro-styles";
import { useToastSaurus } from "services/app";
import { useHistory } from "react-router-dom";
import { RevendaDesempenhoByIdModel } from "model/api/gestao/revendedor/revenda-desempenho-by-id-model";
import { DesempenhoRevendaByIdListData } from "./desempenho-revenda-by-id-list-data";
import { useGetRevendaDesempenhoById } from "data/api/gestao/resultados/get-revenda-desempenho-by-id";
import { ExportarExcelIcon } from "views/components/icons/exportar-excel-icon";
import { useGetRevendaDesempenhoByIdExcel } from "data/api/gestao/resultados/excel/get-revenda-desempenho-excel-by-id";
import { useThemeQueries } from "views/theme";

interface DesempenhoRevendaByIdListProps {
  id: string;
  anoMesApuracao: number;
  setNome: (name: string) => any;
}

export const DesempenhoRevendaByIdList = ({ id, setNome, anoMesApuracao }: DesempenhoRevendaByIdListProps) => {
  const classes = useStyles();
  const listClasses = useDefaultCadastroStyles();
  const {theme} = useThemeQueries();

  const nomeRef = useRef<string>('')

  const { showToast } = useToastSaurus();
  const { push } = useHistory();
  const { getRevendaDesempenhoById, carregando: carregandoGet } = useGetRevendaDesempenhoById();
  const { getRevendaDesempenhoByIdExcel, carregando: carregandoExcel } = useGetRevendaDesempenhoByIdExcel()

  const carregando = carregandoGet || carregandoExcel

  const [list, setList] = useState<RevendaDesempenhoByIdModel[]>([]);

  const search = useCallback(async (newPage: number) => {
    try {

      const res = await getRevendaDesempenhoById(anoMesApuracao, id);
      if (res.erro) throw res.erro;

      if (res.resultado?.data === undefined) {
        return
      }

      setNome(res.resultado.data[0].revenda)
      nomeRef.current = res.resultado.data[0].revenda
      setList(res.resultado.data)


    } catch (e: any) {
      showToast("error", e.message);
    }
  }, [anoMesApuracao, getRevendaDesempenhoById, id, setNome, showToast])

  const getExcel = useCallback(async () => {
    try {
      const res = await getRevendaDesempenhoByIdExcel(anoMesApuracao, id)
      if (res.erro) throw (res.erro)
      if (!res.resultado) return;

      const blob = new Blob([res.resultado?.data], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a')

      anchor.href = url
      anchor.download = `Desempenho-${nomeRef.current}.xls`
      anchor.click()

    } catch (e: any) {
      showToast('error', e.message);
    }
  }, [anoMesApuracao, getRevendaDesempenhoByIdExcel, id, showToast])

  useEffect(() => {
    search(1)
  }, [search])

  const onClickCard = useCallback((anoMes: number) => {
    push('/desempenho-revendedores/' + id + '/mes/' + anoMes)
  }, [id, push])

  return (
    <>
      <div className={classes.defaultContainer}>
        {carregando && <CircularLoading tipo="FULLSIZED" />}
        <Box display='flex' flexDirection='column' height='100%' justifyContent='space-between' flex={1} overflow='auto'>
          <Grid container className={listClasses.listContainer}>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: theme.spacing(1) }}>
              <Card style={{ marginRight: 8, marginLeft: 24, display: 'flex', alignItems: 'center', maxHeight: '40px' }}>
                <Tooltip arrow title="Exportar Excel">
                  <Button color="primary" onClick={() => getExcel()}>
                    <ExportarExcelIcon tipo="BUTTON_EXPORT_MOBILE" />
                  </Button>
                </Tooltip>
              </Card>
            </Grid>
            <Grid item xs={12} className={classes.listContainer}>
              <DesempenhoRevendaByIdListData
                list={list}
                carregando={carregando}
                onClick={onClickCard}
              />
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};